/**
 * WIRELESS SHOP - INTERACTIVE STORE APP & CART BRIDGE
 */

document.addEventListener('DOMContentLoaded', () => {
    initCountdownTimer();
    initScrollReveal();
    initProductGallerySwitching();
    initQuickViewModal();
    initCartDrawer();
    initPolicyModal();
    updateYear();
});

/* --------------------------------------------------------------------------
   0. SCROLL REVEAL ANIMATION (SPAWNING CARDS ON SCROLL)
   -------------------------------------------------------------------------- */
function initScrollReveal() {
    const cards = document.querySelectorAll('.product-card');
    if (!cards.length) return;

    // Use IntersectionObserver to animate cards into view when scrolling
    const observerOptions = {
        root: null,
        rootMargin: '0px 0px -40px 0px',
        threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('reveal-visible');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    cards.forEach((card, index) => {
        // Add a slight staggered transition delay per card in sequence
        card.style.transitionDelay = `${(index % 4) * 0.12}s`;
        observer.observe(card);
    });
}

/* --------------------------------------------------------------------------
   1. LIVE COUNTDOWN TIMER (20 DÍAS DE APERTURA)
   -------------------------------------------------------------------------- */
function initCountdownTimer() {
    let targetDate = localStorage.getItem('wireless_shop_opening_target');
    if (!targetDate) {
        targetDate = new Date(Date.now() + 20 * 24 * 60 * 60 * 1000).getTime();
        localStorage.setItem('wireless_shop_opening_target', targetDate);
    } else {
        targetDate = parseInt(targetDate, 10);
    }

    const daysEl = document.getElementById('timer-days');
    const hoursEl = document.getElementById('timer-hours');
    const minsEl = document.getElementById('timer-mins');
    const secsEl = document.getElementById('timer-secs');

    if (!daysEl) return;

    function updateTimer() {
        const now = Date.now();
        const diff = targetDate - now;

        if (diff <= 0) {
            daysEl.textContent = '00';
            hoursEl.textContent = '00';
            minsEl.textContent = '00';
            secsEl.textContent = '00';
            return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const secs = Math.floor((diff % (1000 * 60)) / 1000);

        daysEl.textContent = String(days).padStart(2, '0');
        hoursEl.textContent = String(hours).padStart(2, '0');
        minsEl.textContent = String(mins).padStart(2, '0');
        secsEl.textContent = String(secs).padStart(2, '0');
    }

    updateTimer();
    setInterval(updateTimer, 1000);
}

/* --------------------------------------------------------------------------
   2. GALLERY THUMBNAIL SWITCHING (HOVER & CLICK)
   -------------------------------------------------------------------------- */
function initProductGallerySwitching() {
    document.addEventListener('mouseover', handleThumbnailSwitch);
    document.addEventListener('click', handleThumbnailSwitch);
}

function handleThumbnailSwitch(e) {
    const thumb = e.target.closest('.product-thumb-item');
    if (!thumb) return;

    const newImgSrc = thumb.getAttribute('data-img');
    if (!newImgSrc) return;

    const card = thumb.closest('.product-card');
    if (card) {
        const mainImg = card.querySelector('.product-image img');
        if (mainImg) {
            mainImg.src = newImgSrc;
        }

        const allThumbs = card.querySelectorAll('.product-thumb-item');
        allThumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
    }

    const modal = thumb.closest('.product-modal-card');
    if (modal) {
        const modalMainImg = modal.querySelector('#qv-main-img');
        if (modalMainImg) {
            modalMainImg.src = newImgSrc;
        }
        const allModalThumbs = modal.querySelectorAll('.product-thumb-item');
        allModalThumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
    }
}

/* --------------------------------------------------------------------------
   3. LIGHTBOX QUICKVIEW POPUP MODAL
   -------------------------------------------------------------------------- */
function initQuickViewModal() {
    const modal = document.getElementById('product-quickview-modal');
    const closeBtn = document.getElementById('quickview-modal-close');
    const overlay = document.getElementById('quickview-modal-overlay');

    if (!modal) return;

    document.addEventListener('click', (e) => {
        const card = e.target.closest('.product-card');
        const buyBtn = e.target.closest('.buy-button');
        const thumb = e.target.closest('.product-thumb-item');

        if (card && !buyBtn && !thumb) {
            openProductQuickView(card);
        }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeProductQuickView);
    if (overlay) overlay.addEventListener('click', closeProductQuickView);

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('active')) {
            closeProductQuickView();
        }
    });
}

function openProductQuickView(card) {
    const modal = document.getElementById('product-quickview-modal');
    if (!modal) return;

    const title = card.querySelector('h3') ? card.querySelector('h3').textContent : '';
    const badge = card.querySelector('.badge') ? card.querySelector('.badge').textContent : 'Inalámbrico';
    const description = card.querySelector('.product-info > p') ? card.querySelector('.product-info > p').textContent : '';
    const oldPrice = card.querySelector('.old-price') ? card.querySelector('.old-price').textContent : '';
    const price = card.querySelector('.price') ? card.querySelector('.price').textContent : '';
    const mainImgSrc = card.querySelector('.product-image img') ? card.querySelector('.product-image img').src : '';
    const specsList = card.querySelector('.tech-specs-list') ? card.querySelector('.tech-specs-list').outerHTML : '';
    const buyBtnCard = card.querySelector('.buy-button');

    document.getElementById('qv-title').textContent = title;
    document.getElementById('qv-badge').textContent = badge;
    document.getElementById('qv-description').textContent = description;
    document.getElementById('qv-old-price').textContent = oldPrice;
    document.getElementById('qv-price').textContent = price;
    document.getElementById('qv-main-img').src = mainImgSrc;

    const specsContainer = document.getElementById('qv-specs-container');
    if (specsContainer) specsContainer.innerHTML = specsList;

    const thumbsStrip = document.getElementById('qv-thumbnails-container');
    if (thumbsStrip) {
        thumbsStrip.innerHTML = '';
        const cardThumbs = card.querySelectorAll('.product-thumb-item');
        cardThumbs.forEach(t => {
            const clone = t.cloneNode(true);
            thumbsStrip.appendChild(clone);
        });
    }

    const qvBuyBtn = document.getElementById('qv-buy-btn');
    if (qvBuyBtn && buyBtnCard) {
        qvBuyBtn.setAttribute('data-id', buyBtnCard.getAttribute('data-id') || '');
        qvBuyBtn.setAttribute('data-name', buyBtnCard.getAttribute('data-name') || title);
        qvBuyBtn.setAttribute('data-price', price);
        qvBuyBtn.setAttribute('data-image', mainImgSrc);
        
        qvBuyBtn.onclick = () => {
            addToCart({
                id: buyBtnCard.getAttribute('data-id'),
                name: buyBtnCard.getAttribute('data-name') || title,
                price: price,
                image: mainImgSrc,
                quantity: 1
            });
            closeProductQuickView();
            openCartDrawer();
        };
    }

    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
}

function closeProductQuickView() {
    const modal = document.getElementById('product-quickview-modal');
    if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
    }
}

/* --------------------------------------------------------------------------
   4. CART DRAWER & LOCAL CART MANAGEMENT
   -------------------------------------------------------------------------- */
let cartState = JSON.parse(localStorage.getItem('wireless_shop_cart') || '[]');

function initCartDrawer() {
    const cartBtn = document.getElementById('cart-btn');
    const closeBtn = document.getElementById('cart-close-btn');
    const overlay = document.getElementById('cart-drawer-overlay');

    const checkoutBtn = document.getElementById('checkout-btn');

    if (cartBtn) cartBtn.addEventListener('click', openCartDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    if (overlay) overlay.addEventListener('click', closeCartDrawer);

    if (checkoutBtn) {
        checkoutBtn.addEventListener('click', async (e) => {
            e.preventDefault();
            if (!cartState || cartState.length === 0) {
                showToast("Tu bolsa de compra está vacía");
                return;
            }
            checkoutBtn.disabled = true;
            checkoutBtn.textContent = 'Cargando Checkout...';
            await syncCartWithShopifyAndCheckout();
        });
    }

    document.addEventListener('click', (e) => {
        const buyBtn = e.target.closest('.buy-button');
        if (buyBtn && !e.target.closest('#product-quickview-modal')) {
            e.stopPropagation();
            const item = {
                id: buyBtn.getAttribute('data-id'),
                handle: buyBtn.getAttribute('data-handle') || buyBtn.getAttribute('data-id'),
                name: buyBtn.getAttribute('data-name'),
                price: buyBtn.getAttribute('data-price'),
                image: buyBtn.getAttribute('data-image'),
                variantId: buyBtn.getAttribute('data-variant-id'),
                quantity: 1
            };
            addToCart(item);
            openCartDrawer();
        }
    });

    renderCart();
}

function openCartDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (drawer) drawer.classList.add('active');
}

function closeCartDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (drawer) drawer.classList.remove('active');
}

async function syncCartWithShopifyAndCheckout() {
    try {
        const itemsToAdd = [];

        for (const item of cartState) {
            let numericVariantId = null;

            if (item.variantId && !isNaN(Number(item.variantId))) {
                numericVariantId = Number(item.variantId);
            } else {
                const handle = item.handle || item.id;
                try {
                    const res = await fetch(`/products/${handle}.js`);
                    if (res.ok) {
                        const productData = await res.json();
                        if (productData && productData.variants && productData.variants.length > 0) {
                            numericVariantId = productData.variants[0].id;
                        }
                    }
                } catch (err) {
                    console.log('Error al obtener variante de Shopify:', handle, err);
                }
            }

            if (numericVariantId) {
                itemsToAdd.push({
                    id: numericVariantId,
                    quantity: item.quantity || 1
                });
            }
        }

        if (itemsToAdd.length > 0) {
            await fetch('/cart/clear.js', { method: 'POST' });
            
            const addRes = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: itemsToAdd })
            });

            if (addRes.ok) {
                window.location.href = '/checkout';
                return;
            }
        }

        window.location.href = '/checkout';
    } catch (err) {
        console.error('Error al procesar checkout:', err);
        window.location.href = '/checkout';
    }
}

function addToCart(product) {
    const existing = cartState.find(item => item.id === product.id);
    if (existing) {
        existing.quantity += 1;
    } else {
        cartState.push(product);
    }
    saveCart();
    renderCart();
    showToast(`"${product.name}" agregado a tu bolsa`);
}

function removeFromCart(id) {
    cartState = cartState.filter(item => item.id !== id);
    saveCart();
    renderCart();
}

function saveCart() {
    localStorage.setItem('wireless_shop_cart', JSON.stringify(cartState));
}

function renderCart() {
    const countEl = document.getElementById('cart-count');
    const itemsContainer = document.getElementById('cart-items-container');
    const totalPriceEl = document.getElementById('cart-total-price');

    const totalCount = cartState.reduce((sum, i) => sum + i.quantity, 0);
    if (countEl) countEl.textContent = totalCount;

    if (!itemsContainer) return;

    if (cartState.length === 0) {
        itemsContainer.innerHTML = '<p class="empty-cart-msg">Tu bolsa de compra está vacía.</p>';
        if (totalPriceEl) totalPriceEl.textContent = '$ 0';
        return;
    }

    let totalCalculated = 0;
    itemsContainer.innerHTML = cartState.map(item => {
        const numPrice = parseInt(item.price.replace(/[^\d]/g, ''), 10) || 0;
        totalCalculated += numPrice * item.quantity;

        return `
            <div class="cart-item" style="display: flex; gap: 12px; margin-bottom: 16px; padding-bottom: 16px; border-bottom: 1px solid rgba(255,255,255,0.05);">
                <img src="${item.image}" alt="${item.name}" style="width: 60px; height: 60px; object-fit: contain; background: rgba(0,0,0,0.3); border-radius: 8px; padding: 4px;">
                <div style="flex-grow: 1;">
                    <h4 style="font-size: 0.9rem; font-weight: 700; margin-bottom: 4px;">${item.name}</h4>
                    <p style="font-size: 0.85rem; color: var(--color-primary); font-weight: 800;">${item.price} <span style="font-size: 0.75rem; color: var(--color-text-muted);">x ${item.quantity}</span></p>
                </div>
                <button onclick="removeFromCart('${item.id}')" style="background: none; border: none; color: #ef4444; font-size: 1.2rem; cursor: pointer; padding: 0 4px;">&times;</button>
            </div>
        `;
    }).join('');

    if (totalPriceEl) {
        totalPriceEl.textContent = `$ ${totalCalculated.toLocaleString('es-UY')}`;
    }
}

/* TOAST NOTIFICATION */
function showToast(message) {
    const toast = document.getElementById('toast-notification');
    const toastMsg = document.getElementById('toast-message');
    if (!toast || !toastMsg) return;

    toastMsg.textContent = message;
    toast.classList.add('active');
    setTimeout(() => {
        toast.classList.remove('active');
    }, 3000);
}

/* POLICY MODAL */
function initPolicyModal() {
    const modal = document.getElementById('policy-modal');
    const closeBtn = document.getElementById('policy-close-btn');
    const overlay = document.getElementById('policy-modal-overlay');
    const actionBtn = document.getElementById('policy-modal-action-btn');

    if (!modal) return;

    document.querySelectorAll('[data-tab]').forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const tabTarget = link.getAttribute('data-tab');
            openPolicyModal(tabTarget);
        });
    });

    if (closeBtn) closeBtn.addEventListener('click', closePolicyModal);
    if (overlay) overlay.addEventListener('click', closePolicyModal);
    if (actionBtn) actionBtn.addEventListener('click', closePolicyModal);
}

function openPolicyModal(tabTarget) {
    const modal = document.getElementById('policy-modal');
    if (!modal) return;

    const tabBtns = modal.querySelectorAll('.policy-tab-btn');
    const tabContents = modal.querySelectorAll('.policy-tab-content');

    tabBtns.forEach(btn => {
        if (btn.getAttribute('data-target') === tabTarget) {
            btn.classList.add('active');
        } else {
            btn.classList.remove('active');
        }
    });

    tabContents.forEach(content => {
        if (content.id === `tab-content-${tabTarget}`) {
            content.classList.add('active');
        } else {
            content.classList.remove('active');
        }
    });

    modal.classList.add('active');
}

function closePolicyModal() {
    const modal = document.getElementById('policy-modal');
    if (modal) modal.classList.remove('active');
}

function updateYear() {
    const yearEl = document.getElementById('year');
    if (yearEl) yearEl.textContent = new Date().getFullYear();
}

window.removeFromCart = removeFromCart;
